module.exports = __webpack_public_path__ + "img/qywxinactive.fac15bd4.png";